import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {
  config,
  CompanyQuery,
  Company,
  CompanyOfferModel,
  CompanyOfferQuery,
  AnnouncementService,
  MemberCard,
  MemberCardQuery,
  ScreenType,
} from '@fgb/core';
import { OwlOptions } from 'ngx-owl-carousel-o';
import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { OwlCarouselSettings } from 'src/app/shared/utilities/owl-carousel-settings';

@Component({
  selector: 'fgb-home-page',
  templateUrl: './home-page.component.html',
  styleUrls: ['./home-page.component.scss'],
})
export class HomePageComponent implements OnInit {
  config = config;
  companies$: Observable<Company[]>;
  featuredOffers$: Observable<CompanyOfferModel[]>;
  memberCard$: Observable<MemberCard | undefined>;
  customOptions: OwlOptions = {
    autoHeight: true,
    autoWidth: true,
    margin: OwlCarouselSettings.Margin,
    autoplay: OwlCarouselSettings.Autoplay,
    autoplayTimeout: OwlCarouselSettings.AutoplayTimeout,
    autoplaySpeed: OwlCarouselSettings.AutoplaySpeed,
    navSpeed: 700,
    navText: ['', ''],
    responsive: {
      0: { items: 1 },
      740: { items: 2 },
      900: { items: 3 },
    },
  };
  screenType = ScreenType;

  constructor(
    private companyQuery: CompanyQuery,
    private companyOfferQuery: CompanyOfferQuery,
    private router: Router,
    private announcementService: AnnouncementService,
    private memberCardQuery: MemberCardQuery
  ) {}

  ngOnInit() {
    firstValueFrom(this.announcementService.fetchAnnouncements());
    this.featuredOffers$ = this.companyOfferQuery.selectFeaturedOffers();
    this.companies$ = this.companyQuery.selectFavouriteCompanies().pipe(
      map((companies) => {
        return companies;
      })
    );
    this.memberCard$ = this.memberCardQuery.selectCurrentCard();
  }

  navigateToOffer(offerId: number) {
    this.router.navigateByUrl(`offers/details/${offerId}`);
  }
}
